import { environment } from 'src/environments/environment';

export class ImagesUtil {
  getImageUrl(imageUrl: string): string {
    if (environment.baseUrl) {
      return environment.baseUrl + imageUrl;
    }

    return imageUrl;
  }
}
